import Page from 'component/Page';
import { useEffect, useMemo, useState } from 'react';
import FormControls from 'component/FormControls';
import sendRequest, { sendPost, sendPut, sendDelete } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import Modal from 'component/Modal';
// import PocUserAdd from './PocUserAdd';
// import PocUserUpdate from './PocUserUpdate';
// import PocUserChangePassword from './PocUserChangePassword';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { useHistory } from 'react-router-dom';
import Paths from 'util/paths';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { useCallback } from 'react';
import { formatDate, getString, nNU, showConfirm, showToast } from 'util/utils';
// import { FaUserGroup } from 'react-icons/fa6';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
// import PocUserCoupon from './PocUserCoupon';

// export const accountRoleNameMap = {
//   0: string.ACCOUNT_ROLE_ADMIN,
//   1: string.ACCOUNT_ROLE_PARENT,
//   2: string.ACCOUNT_ROLE_CHILD,
// };

// export const accountStatusNameMap = {
//   true: string.ACTIVE,
//   false: string.INACTIVE,
// };

const CouponList = () => {
  //-------------------------------HOOKS-------------------------------------------------------------
  const currentUser = useSelector(selectCurrentUser);
  const [ coupon, setCoupon ] = useState([]);
  const [ page, setPage ] = useState(1);
  const [ total, setTotal ] = useState(0);
  const [ pageSize, setPageSize ] = useState(10);
  const isAdmin = useMemo(
    () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
    [ currentUser.accountRole ]
  );
  const isMonitorOnly = useMemo(
    () => currentUser.isMonitorOnly === 1,
    [ currentUser.isMonitorOnly ]
  );
  const [ searchId, setSearchId ] = useState('');
  const [ debouncedSearchId, setDebouncedSearchId ] = useState(searchId);
  const history = useHistory();
	const headers = isAdmin ? [
		string.APP_COUPON_MODEL,
		string.APP_COUPON_SERIAL,
		string.APP_COUPON_ACCOUNT,
		string.APP_COUPON_APP_ID,
		string.APP_COUPON_ACTIVATED_DATE,
		// string.APP_COUPON_MODEL,
	] : [
		string.APP_COUPON_MODEL,
		string.APP_COUPON_SERIAL,
		string.APP_COUPON_ACCOUNT,
		string.APP_COUPON_APP_ID,
		string.APP_COUPON_ACTIVATED_DATE,
		// string.APP_COUPON_MODEL,
	];

  //------------------------------FUNCTIONS----------------------------------------------------------
  const doSearch = useCallback(
    async (page, pageSize, searchKeyword, getAll = false) => {
      let data = await sendPost({
        url: isAdmin ? Urls.pocaccount.getcoupon : Urls.pocaccount.getcoupon,
        body: {
          offset: (page - 1) * pageSize,
          size: pageSize,
          keyword: searchKeyword,
        },
      });
      const { total, result } = data;
      if (!getAll) {
        setCoupon(result);
        setTotal(total);
      }
      return result;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ currentUser ]
  );
  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchId(searchId);
    }, 500);

    return () => {
      clearTimeout(timerId);
    };
  }, [ searchId ]);
  useEffect(() => {
    doSearch(page, pageSize, debouncedSearchId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ page, pageSize, debouncedSearchId, doSearch ]);
  const dataTable = useCallback(
    (data) =>
      data.map((raw, key) => ({
        key: raw.pocId,
        data: isAdmin
          ? [
            raw.modelName,
            raw.serial,
            raw.email,
            raw.username,
            formatDate(raw.createdAt, 'YYYY/MM/DD'),
          ]
          : [
            raw.modelName,
            raw.serial,
            raw.email,
            raw.username,
            formatDate(raw.createdAt, 'YYYY/MM/DD'),
          ],
        raw,
      })),
    []
  );

  //-------------------------------RETURN------------------------------------------------------------
  return (
    <>
      <Page
        title={string.APP_COUPON_LIST}
        body={
          <>
            {/* <FormControls controls={formControls} /> */}
            <Table
              className="nowrap"
              // mainActions={mainActions}
              page={page}
              pageSize={pageSize}
              total={total}
              onPageChanged={setPage}
              onPageSizeChanged={setPageSize}
              headers={headers}
              data={dataTable(coupon)}
              getCSVData={!isMonitorOnly && (async () => {
                return dataTable(await doSearch(1, total, null, true));
              })}
              csvFileName="CouponList"
              isPaging={true}
              // actions={actions}
              search={true}
              onSearch={(value) => setSearchId(value)}
              placeHolder={`${string.POC_LOGIN_ID}`}
            />
          </>
        }
      />
    </>
  );
};
// const CouponList = () => {
//   //-------------------------------HOOKS-------------------------------------------------------------
//   const currentUser = useSelector(selectCurrentUser);
//   const [users, setUsers] = useState([]);
//   const [page, setPage] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [pageSize, setPageSize] = useState(10);

//   const [selectedUser, setSelectedUser] = useState(null);
//   const [passwordUser, setPasswordUser] = useState(null);
//   const [addUser, setAddUser] = useState(null);
//   const [addCoupon, setAddCoupon] = useState(null);
//   const isAdmin = useMemo(
//     () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
//     [currentUser.accountRole]
//   );
//   const [searchId, setSearchId] = useState('');
//   const [debouncedSearchId, setDebouncedSearchId] = useState(searchId);
//   // const [searchData, setSearchData] = useState({});
//   const history = useHistory();
//   const formControls = [];

//   //------------------------------FUNCTIONS----------------------------------------------------------
//   const doSearch = useCallback(
//     async (page, pageSize, searchKeyword, getAll = false) => {
//       if (!nNU(currentUser.id)) {
//         return;
//       }
//       let data = await sendPost({
//         url: isAdmin ? Urls.pocaccount.list : Urls.pocaccount.userlist,
//         body: {
//           id: currentUser.id,
//           offset: (page - 1) * pageSize,
//           size: pageSize,
//           keyword: searchKeyword,
//         },
//       });
//       const { total, result } = data;
//       if (!getAll) {
//         setUsers(result);
//         setTotal(total);
//       }
//       return result;
//     },
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [currentUser]
//   );
//   useEffect(() => {
//     const timerId = setTimeout(() => {
//       setDebouncedSearchId(searchId);
//     }, 500);

//     return () => {
//       clearTimeout(timerId);
//     };
//   }, [searchId]);

//   useEffect(() => {
//     doSearch(page, pageSize, debouncedSearchId);
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [page, pageSize, debouncedSearchId]);

//   const dataTable = useCallback(
//     (data) =>
//       data.map((raw, key) => ({
//         key: raw.pocId,
//         data: isAdmin
//           ? [
//               raw.username,
//               raw.displayName,
//               // (raw.role === 'premium') ? 'プレミアム' : 'トライヤル',
//               raw.sipNumber,
//               nNU(raw.email) ? raw.email : currentUser.email,
//               raw.status === 1 ? '有効' : '無効',
//               raw.status === 1 ? (
//                 <OverlayTrigger
//                   placement="top"
//                   overlay={
//                     raw.status === 1 && (
//                       <Tooltip>{`${raw.username}の${string.POC_ACCOUNT_CH}一覧へ`}</Tooltip>
//                     )
//                   }
//                 >
//                   <Button
//                     style={{
//                       padding: '3px',
//                       minWidth: '4.5em',
//                       display: 'flex',
//                       justifyContent: 'center',
//                     }}
//                     id={raw.pocId}
//                     onClick={(e) => onUserClick(e)}
//                     // overlay={'Test'}
//                   >
//                     {/* <FaUserGroup /> */}
//                     {/* <div><b>CH</b></div> */}
//                     {raw.totalSecretChannels}
//                   </Button>
//                 </OverlayTrigger>
//               ) : null,
//               formatDate(raw.registerDate, 'YYYY/MM/DD'),
//             ]
//           : [
//               raw.username,
//               raw.displayName,
//               // (raw.role === 'premium') ? 'プレミアム' : 'トライヤル',
//               // nNU(raw.email) ? raw.email : '-',
//               raw.status === 1 ? '有効' : '無効',
//               // (raw.status === 0) ? (
//               // 	<OverlayTrigger
//               // 		placement="top"
//               // 		overlay={(<Tooltip>{`${raw.username}の${string.POC_ACCOUNT_REGISTER_TITLE}${string.POC_ACCOUNT_REGISTER}へ`}</Tooltip>)}
//               // 	>
//               // 		<Button
//               // 			style={{padding: '3px',minWidth:'4.5em',display: 'flex',justifyContent: 'center'}}
//               // 			id={raw.pocId}
//               // 			// onClick={(e) => onUserClick(e)}
//               // 			// overlay={'Test'}
//               // 		>
//               // 			{string.POC_ACCOUNT_REGISTER}
//               // 		</Button>
//               // 	</OverlayTrigger>
//               // ) : (
//               // 	<OverlayTrigger
//               // 		placement="top"
//               // 		overlay={(<Tooltip>{`${raw.username}の${string.POC_ACCOUNT_REGISTER_TITLE}${string.POC_ACCOUNT_UNREGISTER}へ`}</Tooltip>)}
//               // 	>
//               // 		<Button
//               // 			style={{padding: '3px',minWidth:'4.5em',display: 'flex',justifyContent: 'center',color: '#cc0000',backgroundColor: '#ffa500'}}
//               // 			id={raw.pocId}
//               // 			// onClick={(e) => onUserClick(e)}
//               // 			// overlay={'Test'}
//               // 		>
//               // 			{string.POC_ACCOUNT_UNREGISTER}
//               // 		</Button>
//               // 	</OverlayTrigger>
//               // ),
//               raw.status === 0 ? (
//                 <OverlayTrigger
//                   placement="top"
//                   overlay={
//                     <Tooltip>{`${raw.username}の${string.POC_ACCOUNT_COUPON_TITLE}${string.POC_ACCOUNT_COUPON}へ`}</Tooltip>
//                   }
//                 >
//                   <Button
//                     style={{
//                       padding: '3px',
//                       minWidth: '4.5em',
//                       display: 'flex',
//                       justifyContent: 'center',
//                     }}
//                     id={raw.pocId}
//                     onClick={(e) => onCouponClick(e)}
//                     // overlay={'Test'}
//                   >
//                     {string.POC_ACCOUNT_COUPON}
//                   </Button>
//                 </OverlayTrigger>
//               ) : null,
//               raw.status === 1 ? (
//                 <OverlayTrigger
//                   placement="top"
//                   overlay={
//                     raw.status === 1 && (
//                       <Tooltip>{`${raw.username}の${string.POC_ACCOUNT_CH}一覧へ`}</Tooltip>
//                     )
//                   }
//                 >
//                   <Button
//                     style={{
//                       padding: '3px',
//                       minWidth: '4.5em',
//                       display: 'flex',
//                       justifyContent: 'center',
//                     }}
//                     id={raw.pocId}
//                     onClick={(e) => onUserClick(e)}
//                     // overlay={'Test'}
//                   >
//                     {/* <FaUserGroup /> */}
//                     {/* <div><b>CH</b></div> */}
//                     {raw.totalSecretChannels}
//                   </Button>
//                 </OverlayTrigger>
//               ) : null,
//               formatDate(raw.registerDate, 'YYYY/MM/DD'),
//             ],
//         raw,
//       })),
//     []
//   );
//   const mainActions = [
//     {
//       icon: 'add',
//       title: string.POC_ACCOUNT_CREATE_TITLE,
//       onClick: () => setAddUser({ valid: true }),
//     },
//   ];
//   const actions = [
//     { render: 'edit', onClick: ({ raw }) => setSelectedUser(raw) },
//     { render: 'password', onClick: ({ raw }) => setPasswordUser(raw) },
//     ({ raw }) => {
//       if (!isAdmin) {
//         return null;
//       }

//       if (raw.status === 1) {
//         return {
//           render: 'ban',
//           className: 'color-danger',
//           onClick: ({ raw }) => {
//             // Existing code for banning
//             let pocData = {
//               pocId: raw.pocId,
//               status: 0,
//               role: 0,
//             };
//             showConfirm({
//               body: string.POC_ACCOUNT_BAN_CONFIRM,
//               defaultAction: () => {
//                 sendPut({
//                   url: Urls.pocaccount.status,
//                   body: pocData,
//                 }).then((res) => {
// 									showToast(string.POC_ACCOUNT_BAN_SUCCESS, 'success');
// 									doSearch(page, pageSize);
// 								}).catch((e) => {
// 									console.log('Delete error');
// 								});
//               },
//             });
//           },
//         };
//       } else if (raw.status === 0) {
// 				return {
// 					render: 'approve',
// 					onClick: ({ raw }) => {
// 						// Existing code for approving
// 						let pocData = {
// 							pocId: raw.pocId,
// 							status: 1,
// 							role: 0,
// 						};
// 						showConfirm({
// 							body: string.POC_ACCOUNT_APPROVE_CONFIRM,
// 							defaultAction: () => {
// 								sendPut({
// 									url: Urls.pocaccount.status,
// 									body: pocData,
// 								}).then((res) => {
// 									showToast(string.POC_ACCOUNT_APPROVE_SUCCESS, 'success');
// 									doSearch(page, pageSize);
// 								}).catch((e) => {
// 									console.log('Approval error');
// 								});
// 							},
// 						});
// 					},
// 				};
//       } else {
//         return null;
//       }
//     },
// 		({ raw }) => {
//       if (!isAdmin) {
//         return null;
//       }
// 			if (raw.status === 0) {
// 				return {
// 					render: 'delete',
//           className: 'color-danger',
// 					onClick: ({ raw }) => {
// 						let pocData = {
// 							pocIds: [
// 								raw.pocId
// 							],
// 						};
// 						showConfirm({
// 							body: getString(string.POC_ACCOUNT_DELETE_CONFIRM, [
// 								raw.username
// 							]),
// 							defaultAction: () => {
// 								sendDelete({
// 									url: Urls.pocaccount.delete,
// 									body: pocData,
// 								}).then((res) => {
// 									showToast(getString(string.POC_ACCOUNT_DELETE_CONFIRM, [raw.username]), 'success');
// 									doSearch(page, pageSize);
// 								}).catch((e) => {});
// 							},
// 						});
// 					},
// 				};
// 			} else {
// 				return null;
// 			}
// 		},
//   ];

//   const onUserClick = (e) => {
//     // console.log(e.currentTarget.id);
//     let id = e.currentTarget.id;
//     history.push(`${Paths.pocaccount.detail}/?id=${id}`);
//   };

//   const onCouponClick = async (e) => {
//     let id = e.currentTarget.id;
//     let data = await sendRequest({
//       url: `${Urls.pocaccount.account}/${id}`,
//     });
//     const { result } = data;
//     setAddCoupon(result);
//   };

//   //-------------------------------RETURN------------------------------------------------------------
//   return (
//     <>
//       <Page
//         title={string.POC_ACCOUNT_MANAGEMENT}
//         body={
//           <>
//             <FormControls controls={formControls} />
//             <Table
//               className="nowrap"
//               mainActions={mainActions}
//               page={page}
//               pageSize={pageSize}
//               total={total}
//               onPageChanged={setPage}
//               onPageSizeChanged={setPageSize}
//               headers={
//                 isAdmin
//                   ? [
//                       string.POC_LOGIN_ID,
//                       string.POC_DISPLAY_NAME,
//                       // string.POC_ACCOUNT_TYPE,
//                       string.POC_ACCOUNT_SIP,
//                       string.POC_ACCOUNT_OWNER,
//                       string.POC_ACCOUNT_STATUS,
//                       string.POC_ACCOUNT_CH,
//                       string.POC_ACCOUNT_REGISTERED_DATE,
//                     ]
//                   : [
//                       string.POC_LOGIN_ID,
//                       string.POC_DISPLAY_NAME,
//                       string.POC_ACCOUNT_STATUS,
//                       // string.POC_ACCOUNT_REGISTER_TITLE,
//                       string.POC_ACCOUNT_COUPON_TITLE,
//                       string.POC_ACCOUNT_CH,
//                       string.POC_ACCOUNT_REGISTERED_DATE,
//                     ]
//               }
//               data={dataTable(users)}
//               getCSVData={async () => {
//                 return dataTable(await doSearch(1, total, true));
//               }}
//               csvFileName="AppUserList"
//               isPaging={true}
//               actions={actions}
//               search={true}
//               onSearch={(value) => setSearchId(value)}
//               placeHolder={`${string.POC_LOGIN_ID}、${string.POC_DISPLAY_NAME}`}
//             />
//           </>
//         }
//       />
//       <Modal
//         show={!!selectedUser}
//         onHide={() => setSelectedUser(null)}
//         body={
//           <>
//             {!!selectedUser && (
//               <PocUserUpdate
//                 onUpdated={() => {
//                   setSelectedUser(null);
//                   doSearch(page, pageSize);
//                 }}
//                 data={selectedUser}
//               />
//             )}
//           </>
//         }
//       />
//       <Modal
//         show={!!passwordUser}
//         onHide={() => setPasswordUser(null)}
//         body={
//           <>
//             {!!passwordUser && (
//               <PocUserChangePassword
//                 onUpdated={() => {
//                   setPasswordUser(null);
//                   doSearch(page, pageSize);
//                 }}
//                 data={passwordUser}
//               />
//             )}
//           </>
//         }
//       />
//       <Modal
//         show={!!addUser}
//         onHide={() => setAddUser(null)}
//         body={
//           <>
//             {!!addUser && (
//               <PocUserAdd
//                 onUpdated={() => {
//                   setAddUser(null);
//                   doSearch(page, pageSize);
//                 }}
//                 data={addUser}
//               />
//             )}
//           </>
//         }
//       />
//       <Modal
//         show={!!addCoupon}
//         onHide={() => setAddCoupon(null)}
//         body={
//           <>
//             {!!addCoupon && (
//               <PocUserCoupon
//                 onUpdated={() => {
//                   setAddCoupon(null);
//                   doSearch(page, pageSize);
//                 }}
//                 data={addCoupon}
//               />
//             )}
//           </>
//         }
//       />
//     </>
//   );
// };

export default CouponList;
